import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BautagebuchService } from '../../../../services/bautagebuch.service';
import { DataOfferCatalogDetailDto } from '../../../../models/bautagebuch.models';

export interface PurchaseDialogData {
  organisationId: number;
  offerId: string;
  offerTitle: string;
  producerOrgName: string;
  pricingLabel: string;
  permissionsLabel: string;
  validityLabel: string;
  reportCount: number;
}

@Component({
  standalone: false,
  selector: 'app-purchase-dialog',
  templateUrl: './purchase-dialog.component.html',
  styleUrls: ['./purchase-dialog.component.scss']
})
export class PurchaseDialogComponent {
  state: 'confirm' | 'loading' | 'success' = 'confirm';
  error = '';

  constructor(
    private readonly dialogRef: MatDialogRef<PurchaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PurchaseDialogData,
    private readonly bautagebuchService: BautagebuchService
  ) {}

  confirm(): void {
    this.state = 'loading';
    this.error = '';
    const startTime = Date.now();

    this.bautagebuchService.confirmDataOfferFakePayment(
      this.data.organisationId,
      this.data.offerId
    ).subscribe({
      next: (detail: DataOfferCatalogDetailDto) => {
        const elapsed = Date.now() - startTime;
        const remaining = Math.max(0, 1500 - elapsed);
        setTimeout(() => {
          this.state = 'success';
          this._resultDetail = detail;
        }, remaining);
      },
      error: (err) => {
        this.state = 'confirm';
        this.error = err?.message || 'Zahlung konnte nicht verarbeitet werden.';
      }
    });
  }

  private _resultDetail: DataOfferCatalogDetailDto | null = null;

  cancel(): void {
    this.dialogRef.close(null);
  }

  closeSuccess(): void {
    this.dialogRef.close(this._resultDetail);
  }
}
